module.exports = __webpack_public_path__ + "assets/img/page-background-d-7db846ee.png";